import React, { FC } from 'react';
import {
  AttachmentsAPI,
  FileAttachment,
  UploadFileWithAttachment,
} from 'api/attachments';
import {
  AttachmentsTabViews,
  TaskAttachments,
} from 'components/molecules/tasks/details/attachments';
import { ProjectTemplateTask } from 'data/templates/projects';

export const AttachmentsSectionPanel: FC<{
  task: ProjectTemplateTask;
  view: AttachmentsTabViews;
  onUpdateTask(task: ProjectTemplateTask): void;
}> = ({ task, view, onUpdateTask }) => {
  const onAttachmentChange = (list: UploadFileWithAttachment[]) => {
    const attachments = list.reduce((acc: FileAttachment[], file) => {
      return file.attachment ? [...acc, file.attachment] : [...acc];
    }, []);

    onUpdateTask({
      ...task,
      attachments,
    });
  };

  const onUploadAttachment = (file: File) =>
    AttachmentsAPI.attachTemplateTaskFile(file);

  return (
    <TaskAttachments.List
      data={task.attachments}
      view={view}
      onChange={onAttachmentChange}
      onUploadRequest={onUploadAttachment}
    />
  );
};
